<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { spendTooltip, type SpendParams } from "../../actions/tooltip";
  import TextNew from "../TextNew.svelte";
  import Skeleton from "../skeletons/Skeleton.svelte";
  import Card, { type CardRoundness } from "../data-display/Card.svelte";

  export let label: string;
  export let tooltipParams: SpendParams | undefined = undefined;
  export let roundness: CardRoundness = "m";

  const dispatch = createEventDispatcher();

  function handleClick() {
    dispatch("cardclick");
  }

  function handleKeypress(event: KeyboardEvent) {
    if (event.key === "Enter") {
      handleClick();
    }
  }
</script>

<Card --card-minH="82px" {roundness}>
  <div use:spendTooltip={tooltipParams} on:click={handleClick} on:keypress={handleKeypress}>
    <div class="label">
      {#if !$$slots.display}
        <Skeleton --skeleton-height="12px" --skeleton-width="70px" />
      {:else}
        <TextNew size="s" font="ocr" --rk-text-color="var(--rekki-neutral-03)">{label}</TextNew>
      {/if}
    </div>

    {#if !$$slots.display}
      <Skeleton --skeleton-height="24px" --skeleton-width="130px" />
    {/if}

    <slot name="display" />
  </div>
</Card>

<style>
  .label {
    margin-bottom: 16px;
  }
</style>
